const UUID_CORE = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}'
const UUID_EXACT_RE = new RegExp(`^${UUID_CORE}$`)
const TRAILING_UUID_RE = new RegExp(`(?:^|/)(${UUID_CORE})$`)

/** Accepts a canonical UUID, or a pasted admin-portal URL/path ending in one; otherwise null. */
export const normalizeMeetingId = (raw: string | undefined): string | null => {
  const trimmed = raw?.trim().toLowerCase()
  if (!trimmed) return null
  if (UUID_EXACT_RE.test(trimmed)) return trimmed
  const stripped = trimmed.replace(/[?#].*$/, '').replace(/\/+$/, '')
  const match = stripped.match(TRAILING_UUID_RE)
  return match ? match[1] : null
}
